import * as types from "./types";
import { IPaidOptions } from "@/interfaces/IPaidOptions";

const mutations = {
	// Информация для формы - Оплата (каналы)
	[types.PAY_CHANNEL_DETAIL](
		state: { payChannelDetailState: object },
		payChannelDetailState: object
	) {
		state.payChannelDetailState = payChannelDetailState;
	},

	// Покупка каналов
	[types.PAY_CHANNEL](
		state: { payChannelState: object },
		payChannelState: object
	) {
		state.payChannelState = payChannelState;
	},

	// Пополнение баланса
	[types.PAY_BALANCE](
		state: { payBalanceState: object },
		payBalanceState: object
	) {
		state.payBalanceState = payBalanceState;
	},

	// Успешное пополнение
	[types.PAY_SUCCESS](
		state: { paySuccessState: object },
		paySuccessState: object
	) {
		state.paySuccessState = paySuccessState;
	},

	// Оплата не прошла
	[types.PAY_FAIL](state: { payFailState: object }, payFailState: object) {
		state.payFailState = payFailState;
	},

	// Количество активированных каналов
	[types.PAY_ACTIVATED_CHANNELS](
		state: { payActivatedChannelsState: object },
		payActivatedChannelsState: object
	) {
		state.payActivatedChannelsState = payActivatedChannelsState;
	},

	// Установка баланса клиента
	[types.PAY_GET_BALANCE](
		state: { payGetBalanceState: number | null },
		payGetBalanceState: number | null
	) {
		state.payGetBalanceState = payGetBalanceState;
	},

	// История покупок
	[types.PAY_HISTORY](state: { payHistoryState: [] }, payHistoryState: []) {
		state.payHistoryState = payHistoryState;
	},

	// Покупка опций
	[types.PAY_OPTIONS](
		state: { payOptionsState: object },
		payOptionsState: object
	) {
		state.payOptionsState = payOptionsState;
	},

	// Покупка опций прошла успешно
	[types.PAY_OPTIONS_SUCCESS](
		state: { payOptionsSuccessState: object },
		payOptionsSuccessState: object
	) {
		state.payOptionsSuccessState = payOptionsSuccessState;
	},

	// Связь опций с инстансом
	[types.PAY_OPTIONS_LNK_INSTANCE](
		state: { payOptionsLnkInstanceState: IPaidOptions[] },
		payOptionsLnkInstanceState: IPaidOptions[] | null
	) {
		// API может вернуть null, но компоненты ожидают массив и читают .length.
		state.payOptionsLnkInstanceState = Array.isArray(payOptionsLnkInstanceState)
			? payOptionsLnkInstanceState
			: [];
	},

	// Автопродление опции (для checkbox)
	[types.AUTO_RENEWAL_OPTION](
		state: { autoRenewalOptionState: [] },
		autoRenewalOptionState: []
	) {
		state.autoRenewalOptionState = autoRenewalOptionState;
	},

	// Продление опций
	[types.PAY_OPTIONS_RENEWAL](
		state: { payOptionsRenewalState: object },
		payOptionsRenewalState: object
	) {
		state.payOptionsRenewalState = payOptionsRenewalState;
	},
};

export default mutations;
